import {html} from 'lit';

export const facet9Template = () => html`
    <div class="image-shapes-9--crop-mobile">
        <svg version="1.1" id="Ebene_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
            viewBox="0 0 360 270" xml:space="preserve">
            <path class="fill-lightblue400" d="M303.3,141.1l54.7,31.7V236l-54.8,31.7L248.4,236v-63.2L303.3,141.1 M303.3,138.8l-56.9,32.8v65.6l56.8,32.8
            l56.8-32.8v-65.6L303.3,138.8L303.3,138.8z"/>
            <polygon class="fill-yellow600" points="63.9,196.1 -0.1,159.4 -0.1,233 "/>
            <polygon class="fill-yellow400" points="-0.1,233 63.9,196.1 127.9,233 63.9,270 "/>
        </svg>
    </div>

    <div class="image-shapes-9">
        <svg version="1.1" id="Ebene_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
            viewBox="0 0 380 301" xml:space="preserve">
            <g>
                <path class="fill-lightblue400" d="M303.3,15.6l37.8,21.8V81l-37.8,21.8L265.5,81V37.4L303.3,15.6 M303.3,13.2l-39.9,23v45.9l39.8,23l39.8-23
                V36.2L303.3,13.2L303.3,13.2z"/>
            </g>
                <polygon class="fill-yellow600" points="91.3,238.1 36.9,206.9 36.9,269.5 "/>
            <g>
                <polygon class="fill-yellow400" points="36.9,269.5 91.3,238.1 145.7,269.5 91.3,300.9 	"/>
            </g>
        </svg>
    </div>
`;